export const orlisLogoUrl = "https://customer-assets-jt897jd0.emergentagent.net/job_oramy-mobile-first/artifacts/671edc87882ed60a_ORAMY_logo_512x512.png";
export const apkDownloadUrl = "/downloads/oramy.apk";
export const playStoreUrl = "https://play.google.com/store/apps/details?id=com.oramy.ai&pcampaignid=web_share";


export const screenshots = [
  {
    id: "home-chat",
    name: "AI Chat",
    category: "core",
    section: "AI Chat",
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_c9a5fb7f-2531-4b1e-95a8-65a8281f0e26/artifacts/obrntwj0_WhatsApp%20Image%202026-08-31%20at%204.35.19%20PM.jpeg",
    caption: "Ask anything — study help, ideas, code, or plans.",
  },
  {
    id: "riva",
    name: "RIVA",
    category: "voice",
    section: "RIVA Voice",
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_c9a5fb7f-2531-4b1e-95a8-65a8281f0e26/artifacts/hqpscayl_WhatsApp%20Image%202026-08-31%20at%204.35.24%20PM.jpeg",
    caption: "A live conversation when speaking is easier.",
  },
  {
    id: "models-selected",
    name: "Model selector — selected",
    category: "core",
    section: "AI Models",
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_c9a5fb7f-2531-4b1e-95a8-65a8281f0e26/artifacts/rnznjytx_WhatsApp%20Image%202026-08-31%20at%204.35.25%20PM.jpeg",
    caption: "A model choice for the task in front of you.",
  },
  {
    id: "models-list",
    name: "Model selector — models",
    category: "core",
    section: "AI Models",
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_c9a5fb7f-2531-4b1e-95a8-65a8281f0e26/artifacts/ktg3373p_WhatsApp%20Image%202026-08-31%20at%204.35.28%20PM.jpeg",
    caption: "Fast, reasoning, coding, vision and multimodal choices.",
  },
  {
    id: "navigation",
    name: "ORLIS navigation",
    category: "worlds",
    section: "One app",
    src: "https://customer-assets-lqy194kg.emergentagent.net/job_c9a5fb7f-2531-4b1e-95a8-65a8281f0e26/artifacts/xcy7ekax_WhatsApp%20Image%202026-08-31%20at%204.35.40%20PM.jpeg",
    caption: "One assistant connecting every ORLIS world.",
  },
  {
    id: "study-progress",
    name: "Study Progress",
    category: "study",
    section: "Study Hub",
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_oramy-mobile-first/artifacts/m4vgnp8e_WhatsApp%20Image%202026-08-31%20at%204.35.43%20PM%20%281%29.jpeg",
    caption: "See learning activity, quizzes, flashcards and notes together.",
  },
  {
    id: "study-hub",
    name: "Study Hub",
    category: "study",
    section: "Study Hub",
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_oramy-mobile-first/artifacts/ng31yx5k_WhatsApp%20Image%202026-08-31%20at%204.35.43%20PM.jpeg",
    caption: "A personalized study workspace with focused tools.",
  },
  {
    id: "creator-overview",
    name: "Creator Hub — video & optimize",
    category: "create",
    section: "Creator Hub",
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_oramy-mobile-first/artifacts/i44yk2bm_WhatsApp%20Image%202026-08-31%20at%204.35.44%20PM%20%281%29.jpeg",
    caption: "Move from visual creation to video and optimization.",
  },
  {
    id: "creator-content",
    name: "Creator Hub — content creation",
    category: "create",
    section: "Creator Hub",
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_oramy-mobile-first/artifacts/l8h5t1xb_WhatsApp%20Image%202026-08-31%20at%204.35.44%20PM.jpeg",
    caption: "Start with scripts, hooks, ideas and repurposing.",
  },
  {
    id: "professional-overview",
    name: "Professional Hub — analysis & coding",
    category: "work",
    section: "Professional Hub",
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_oramy-mobile-first/artifacts/y4t84hdl_WhatsApp%20Image%202026-08-31%20at%204.35.45%20PM%20%281%29.jpeg",
    caption: "Research, analyze, plan and code in one workspace.",
  },
  {
    id: "professional-documents",
    name: "Professional Hub — documents",
    category: "work",
    section: "Professional Hub",
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_oramy-mobile-first/artifacts/0104gb7a_WhatsApp%20Image%202026-08-31%20at%204.35.45%20PM.jpeg",
    caption: "Generate and work through documents with less friction.",
  },
  {
    id: "support",
    name: "Help & Support",
    category: "support",
    section: "Help & Support",
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_oramy-mobile-first/artifacts/t6nuntkf_WhatsApp%20Image%202026-08-31%20at%204.35.46%20PM.jpeg",
    caption: "Open a ticket for questions, bugs, payments, accounts or features.",
  },
  {
    id: "radar",
    name: "Radar",
    category: "radar",
    section: "Radar",
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_oramy-mobile-first/artifacts/6jzn5wz1_WhatsApp%20Image%202026-08-31%20at%204.39.40%20PM.jpeg",
    caption: "Explore useful and timely information inside your workspace.",
  },
];

export const pricingPlans = [
  { id: "free", name: "Free", price: "₹0", note: "A clear place to begin." },
  { id: "basic", name: "Basic", price: "₹299", note: "For everyday momentum." },
  { id: "plus", name: "Plus", price: "₹899", note: "For more room to explore." },
  { id: "pro", name: "Pro", price: "₹1,899", note: "For ambitious workflows." },
  { id: "max", name: "Max", price: "₹14,999", note: "For the full ORLIS experience." },
];

export const faqItems = [
  ["What is ORLIS AI?", "ORLIS AI brings chat, learning, creation and professional work into one experience."],
  ["What can ORLIS do?", "ORLIS brings together AI chat, model selection, voice conversation, Radar, Study Hub, Creator Hub and Professional Hub tools."],
  ["Is there a free plan?", "Yes. ORLIS has a Free plan alongside Basic, Plus, Pro and Max monthly plans."],
  ["What is DepthView?", "DepthView turns a normal question into a deeper, more structured AI exploration when the task needs more than a quick answer."],
  ["What is RIVA?", "RIVA is ORLIS’s live voice conversation experience. The supplied app screen shows language and voice selection controls."],
  ["What is Radar?", "Radar helps you explore useful and timely information through ORLIS without leaving your AI workspace."],
  ["What is Study Hub?", "Study Hub brings learning tools such as quizzes, mock viva, flashcards, notes, homework, revision, career guidance, mind maps, planning and YouTube AI together."],
  ["What is Creator Hub?", "Creator Hub brings together scripts, hooks, content ideas, repurposing, thumbnails, video, analysis, SEO and planning tools."],
  ["What is Professional Hub?", "Professional Hub brings together documents, writing, email, resumes, meeting summaries, proposals, reports, research, tables, planning and coding."],
  ["Can subscriptions be cancelled?", "Subscription controls and any cancellation terms should be reviewed in the ORLIS account experience and confirmed in the final commercial policy."],
];

export const contactDetails = {
  phones: ["+91 9149815646", "+91 6006455295"],
  emails: ["m assaidshah3@gmail.com".replace(" ", ""), "arbaazkazmi0@gmail.com"],
  founder: "Massaid Shah — founder, a 17 year old boy from remote valleys of Jammu & Kashmir in the Himalayas.",
  cofounder: "Sohail Abass Shah — co-founder, marketing expert and lab technician.",
};
